<template>
  <div class="session-base">
    <header-base @open-dialog='disableTimer' @close-dialog='enableTimer' pageType='session'/>
    <list-session-item v-if='invalidSession' name='[REDACTED]' creator='[REDACTED]' :id='$route.params.id' type='invalid' />
    <v-container v-else style='max-width: unset; margin: unset;'>
      <v-layout>
        <v-flex xs12 md10>
          <v-btn small @click='sessionChatOpen = true' class='chatbutton'>Chat</v-btn>
          <timer-base @begin-timer='disableNewData()' @stop-timer='(v, t) => {addSolveToSession(v, t); enableNewData()}' ref='timer'/>
          <session-times @open-dialog='disableTimer' @close-dialog='enableTimer' ref='sessionTimes'/>
        </v-flex>
        <v-flex md2>
          <v-layout column>
            <session-tools id='tools' :scramble='$store.state.scramble'/>
            <v-flex class='chatbox'>
              <session-chat @open-dialog='disableTimer' @close-dialog='enableTimer' :messages='chatMessages'/>
            </v-flex>
            <vue-slideout-panel v-model='sessionChatOpen' @close='sessionChatOpen = false' class='chatslideout'>
              <session-chat @open-dialog='disableTimer' @close-dialog='enableTimer' :messages='chatMessages'/>
            </vue-slideout-panel>
        </v-layout>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import io from 'socket.io-client'

import ListSessionItem from '@/components/ListSessionItem'
import SessionTimes from '@/components/SessionTimes'
import SessionChat from '@/components/SessionChat'
import HeaderBase from '@/components/HeaderBase'
import TimerBase from '@/components/TimerBase'
import VueSlideoutPanel from '@/components/VueSlideoutPanel'
import SessionTools from '@/components/SessionTools'

import SessionsService from '@/services/SessionsService'
export default {
  name: 'session-base',
  data () {
    return {
      invalidSession: false,
      chatMessages: [{solver: 'SessionBot', text: "Welcome to the sesssion! You can send messages to each other here but they won't be saved. Remember to be nice :D"}],
      sessionChatOpen: false
    }
  },
  methods: {
    async addSolveToSession (metadata, type) {
      if (metadata === undefined) return
      let currSolveData = (type === 'update' && this.$store.state.lastSolveData.time) ? this.$store.state.lastSolveData : { time: this.$store.state.time, comment: this.$store.state.comment, scrambleId: this.$store.state.scrambleId }
      await SessionsService.addTime(this.$store.state.sessionId, {
        time: {
          time: currSolveData.time,
          plusTwo: metadata === '+2',
          DNF: metadata === 'dnf',
          comment: currSolveData.comment,
        },
        solverId: this.$store.state.solverId,
        authToken: this.$store.state.authToken,
        globalAuthToken: this.$store.state.globalAuthToken,
        scrambleId: currSolveData.scrambleId
      })
      this.$store.commit('setLastSolveData', currSolveData)
      this.$refs.sessionTimes.redoLatestSolve()
    },
    enableTimer () {
      this.$refs.timer.timerEnabled = true
    },
    disableTimer () {
      this.$refs.timer.timerEnabled = false
    },
    enableNewData () {
      // if we enable new data then overwrite the old data and reenable sync (reenabling sync will be done asynchronously in the overwriteData function)
      this.$refs.sessionTimes.overwriteData()
    },
    disableNewData () {
      this.$refs.sessionTimes.syncData = false
    }
  },
  watch: {
    sessionChatOpen () {
      this.$refs.timer.timerEnabled = !this.sessionChatOpen
    }
  },
  computed: {
    isSpectator () {
      return this.$route.params.viewerType === 'spectate' || this.$route.params.viewerType === 'stream'
    }
  },
  components: {
    ListSessionItem,
    SessionTimes,
    SessionChat,
    TimerBase,
    HeaderBase,
    VueSlideoutPanel,
    SessionTools
  },
  created () {
    this.$store.commit('setSessionId', this.$route.params.id)
    this.$store.commit('setSolverId', localStorage.getItem('globalSolverId'))
    this.$store.commit('setAuthToken', localStorage.getItem('token:' + this.$route.params.id))
    this.$store.commit('setGlobalAuthToken', localStorage.getItem('globalAuthToken'))
    this.$store.commit('setSolver', localStorage.getItem('globalSolver'))

    this.$store.state.socket = io.connect(this.$backendHost, {
      query: {
        connectionType: 'session',
        solverId: this.$store.state.solverId,
        authToken: this.$store.state.authToken,
        globalAuthToken: this.$store.state.globalAuthToken,
        sessionId: this.$store.state.sessionId,
        spectate: this.isSpectator,
      }
    })

    this.$store.state.socket.on('ehlo', async () => {
      await this.$refs.sessionTimes.initSessionTimes()
      this.$refs.sessionTimes.redoLatestSolve()
    })

    this.$store.state.socket.on('connectFail', (data) => {
      if (data.failState === 'badAuthToken') {
        // wrong or missing auth token
        alert('Failed authentication. Retry again from the home page or enter password below')
        this.invalidSession = true
      } else {
        // miscellaneous error
        alert('Hmmm... Something went wrong and I have no idea what caused it. Yikes.')
        this.$router.push({ path: '/' })
      }
    })

    // handle chat messages in SessionBase because SessionChat gets destroyed when chatbox is closed
    this.$store.state.socket.on('chat', (data) => {
      this.chatMessages.push(data)
    })
  },
  destroyed () {
    this.$store.state.socket.disconnect()
    this.$store.state.socket = null
    this.$store.commit('setScramble', '')
    this.$store.commit('setScrambleId', '')
    this.$store.commit('setSessionId', '')
    this.$store.commit('setAuthToken', '')
  }
}
</script>

<style scoped>
.chatbutton, .chatslideout {
  display: none;
}
.chatbox {
  display: inline;
}

#tools {
  background: #efffe7f0;
}

@media only screen and (max-width: 1080px) {
  .chatbutton, .chatslideout {
    display: inline;
  }
  .chatbox {
    display: none;
  }
}
</style>
